export default "__VITE_ASSET__Bo2S4DnG__"